import React, { useState, useEffect } from 'react';
import api from '../services/api';
import Modal from '../components/Modal';
import Pagination from '../components/Pagination';

const PAGE_SIZE = 15;

export default function Groups() {
  const [groups, setGroups] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: '', description: '', members: [] });
  const [users, setUsers] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => { loadGroups(); }, [page, search]);
  async function loadGroups() {
    const { data } = await api.get('/groups', {
      params: { page, limit: PAGE_SIZE, search: search || undefined },
    });
    setGroups(data.data);
    setTotal(data.total);
  }
  // /users nega Manutencao, que tambem gerencia grupos
  async function loadUsers() { try { const { data } = await api.get('/users/options', { params: { limit: 200 } }); setUsers(data.data); } catch {} }

  function openCreate() { setEditing(null); setForm({ name: '', description: '', members: [] }); setError(''); loadUsers(); setShowModal(true); }
  async function openEdit(group) {
    setEditing(group); loadUsers();
    try { const { data } = await api.get(`/groups/${group.id}`); setForm({ name: data.name, description: data.description || '', members: data.members.map((m) => m.id) }); } catch {}
    setError(''); setShowModal(true);
  }

  async function handleSave() {
    setError('');
    try {
      if (editing) { await api.put(`/groups/${editing.id}`, form); } else { await api.post('/groups', form); }
      setShowModal(false); loadGroups();
    } catch (err) { setError(err.response?.data?.error || 'Erro'); }
  }
  async function handleDelete(id) { if (!window.confirm('Excluir?')) return; try { await api.delete(`/groups/${id}`); loadGroups(); } catch (err) { alert(err.response?.data?.error); } }

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-xl font-bold tracking-tight">Grupos de Usuários</h1>
        <button className="btn btn-primary" onClick={openCreate}>Novo Grupo</button>
      </div>
      <input
        className="form-input mb-4 max-w-[320px]"
        placeholder="Buscar grupo..."
        value={search}
        onChange={(e) => { setSearch(e.target.value); setPage(1); }}
      />
      <div className="bg-surface-100 border rounded-md p-4">
        <table className="w-full border-collapse">
          <thead><tr className="border-b">
            <th className="text-left text-2xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2">Nome</th>
            <th className="text-left text-2xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2">Descrição</th>
            <th className="text-left text-2xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2">Membros</th>
            <th className="text-left text-2xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2">Ações</th>
          </tr></thead>
          <tbody>
            {groups.map((g) => (
              <tr key={g.id} className="border-b border-subtle hover:bg-surface-inset">
                <td className="px-3 py-3 font-medium">{g.name}</td>
                <td className="px-3 py-3 text-sm text-ink-muted">{g.description || '—'}</td>
                <td className="px-3 py-3"><span className="doc-code">{g.member_count}</span></td>
                <td className="px-3 py-3"><div className="flex gap-1">
                  <button className="btn btn-sm btn-secondary" onClick={() => openEdit(g)}>Editar</button>
                  <button className="btn btn-sm btn-danger" onClick={() => handleDelete(g.id)}>Excluir</button>
                </div></td>
              </tr>
            ))}
          </tbody>
        </table>
        <Pagination page={page} total={total} limit={PAGE_SIZE} onPageChange={setPage} />
      </div>
      {showModal && (
        <Modal title={editing ? 'Editar Grupo' : 'Novo Grupo'} onClose={() => setShowModal(false)}>
          {error && <div className="p-3 rounded-md text-sm mb-4 bg-status-rejected/10 text-status-rejected border border-status-rejected/20">{error}</div>}
          <div className="mb-4"><label className="block text-sm font-medium text-ink-secondary mb-1">Nome</label>
            <input className="form-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></div>
          <div className="mb-4"><label className="block text-sm font-medium text-ink-secondary mb-1">Descrição</label>
            <textarea className="form-textarea" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} /></div>
          <div className="mb-4"><label className="block text-sm font-medium text-ink-secondary mb-1">Membros</label>
            <select className="form-select min-h-[120px]" multiple value={form.members}
              onChange={(e) => setForm({ ...form, members: Array.from(e.target.selectedOptions, (o) => o.value) })}>
              {users.map((u) => <option key={u.id} value={u.id}>{u.name} ({u.email})</option>)}
            </select></div>
          <div className="flex gap-3 justify-end mt-5">
            <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancelar</button>
            <button className="btn btn-primary" onClick={handleSave}>Salvar</button>
          </div>
        </Modal>
      )}
    </div>
  );
}
